<template>
    <div
        @click="$root.$emit(`bv::hide::popover`)"
        class="mr-auto profile"
        v-if="!_isTvView"
    >
        <span v-if="data.appointmentStatus && data.appointmentStatus.id == 8">
            <a
                @click.prevent="accept"
                v-if="_hasAccess('schedule.appointment.update')"
                href="#0"
            >
                <i class="famfamfam-silk accept ml-2 mr-1"></i>Accept
            </a>
            <a
                @click.prevent="reschedule"
                v-if="_hasAccess('schedule.appointment.update')"
                href="#0"
            >
                <i class="famfamfam-silk date_error mx-1"></i>Reschedule
            </a>
            <a
                @click.prevent="reject"
                v-if="_hasAccess('schedule.appointment.delete')"
                href="#0"
            >
                <i class="famfamfam-silk delete mx-1"></i>Reject
            </a>
            <a
                @click.prevent="historyClick"
                v-if="data.appointmentStatus"
                href="#0"
            >
                <i class="famfamfam-silk book mx-1"></i>History
            </a>
        </span>
        <span v-else>
            <a
                @click.prevent="checkin"
                v-if="
                    _hasAccess('schedule.appointment.checkin') &&
                    data.type == 0 &&
                    data.appointmentStatus &&
                    _.includes(
                        [
                            APPOINTMENT.STATUS_NOT_CONFIRMED,
                            APPOINTMENT.STATUS_CONFIRMED,
                            APPOINTMENT.STATUS_PREVISIT
                        ],
                        data.appointmentStatus.id
                    )
                "
                href="#0"
            >
                <i class="famfamfam-silk accept mx-1"></i>Check In
            </a>
            <a
                @click.prevent="checkout"
                v-if="
                    data.type == 0 &&
                    data.appointmentStatus &&
                    _.includes([4, 5, 6], data.appointmentStatus.id) &&
                    _hasAccess('schedule.appointment.checkout')
                "
                href="#0"
            >
                <i class="famfamfam-silk door_out mx-1"></i>Check Out
            </a>
            <a
                @click.once="edit"
                v-if="
                    _hasAccess('schedule.appointment.update') &&
                    data.appointmentStatus &&
                    _.includes([0, 1, 2, 19, 11], data.appointmentStatus.id)
                "
                href="javascript:void(0)"
            >
                <i class="famfamfam-silk page_white_edit mx-1"></i>Edit
            </a>
            <a
                @click.prevent="undo"
                v-if="
                    data.type == 0 &&
                    data.appointmentStatus &&
                    _.includes([4, 5, 6, 15], data.appointmentStatus.id) &&
                    data.undoable &&
                    _hasAccess('schedule.appointment.uncheckin')
                "
                href="#0"
            >
                <i class="famfamfam-silk arrow_undo mx-1"></i>Undo Check In
            </a>
            <a
                @click.prevent="duplicate"
                v-if="
                    _hasAccess('schedule.appointment.create') &&
                    data.appointmentStatus
                "
                href="#0"
            >
                <i class="famfamfam-silk page_copy mx-1"></i>Duplicate
            </a>
            <a
                @click.prevent="print"
                v-if="
                    data.type == 0 &&
                    data.appointmentStatus &&
                    data.appointmentStatus.id &&
                    _.isObject(data.patient)
                "
                href="#0"
            >
                <i class="famfamfam-silk printer mx-1"></i>Cage Card
            </a>
            <a
                @click.prevent="cancel"
                v-if="
                    data.appointmentStatus &&
                    _.includes([1, 2, 8], data.appointmentStatus.id) &&
                    _hasAccess('schedule.appointment.delete')
                "
                href="#0"
            >
                <i class="famfamfam-silk delete mx-1"></i>Cancel
            </a>
            <a
                @click.prevent="historyClick"
                v-if="data.appointmentStatus"
                href="#0"
            >
                <i class="famfamfam-silk book mx-1"></i>History
            </a>
        </span>
    </div>
</template>
<script>
import ScheduleHelper from "@/module/schedule/helper";
export default {
    components: {},
    mixins: [ScheduleHelper],
    props: ["data"],
    data() {
        return {};
    },
    computed: {
        start() {
            return moment(this.data.start);
        },
        end() {
            return moment(this.data.end);
        },
        permissions() {
            return this.$root.permissions;
        }
    },
    methods: {
        historyClick(event) {
            this.$emit("history-click", event, this.data);
        },
        edit(event) {
            this.$emit("edit", event, this.data);
        },
        duplicate(event) {
            this.$emit("duplicate", event, this.data);
        },
        checkin(event) {
            this.$emit("checkin", event, this.data);
        },
        undo(event) {
            this.$emit("undo", event, this.data);
        },
        checkout(event) {
            this.$emit("checkout", event, this.data);
        },
        accept(event) {
            this.$emit("accept", event, this.data);
        },
        reject(event) {
            this.$emit("reject", event, this.data);
        },
        reschedule(event) {
            this.$emit("reschedule", event, this.data);
        },
        cancel(event) {
            this.$emit("cancel", event, this.data);
        },
        print(event) {
            this.$emit("print", event, this.data);
        }
    }
};
</script>
